import axios from '../../config/axiosConfig';
import { CREATE_AREA, GET_AREAS, AREA_REQUEST, DELETE_AREA, UPDATE_AREA, AREA_REQUEST_FAILURE, GET_AREAS_PAGE, AREA_REQUEST_SUCCESS } from '../types';
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getAreasWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: AREA_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
      };
      return axios.get("/area/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_AREAS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: AREA_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: AREA_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAreas = (commonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: AREA_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            if (commonMaster !== undefined) {
                params = {
                  ...params,
                  companyId: commonMaster ? undefined : auth.company?.id
                };
              }
            return axios.get('/area/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_AREAS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: AREA_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: AREA_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getAreaById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: AREA_REQUEST });
      return axios.get(`/area/get/${id}`).then((response) => {
        dispatch({ type: AREA_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: AREA_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: AREA_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createArea = (data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { area } = getState();
            dispatch({ type: AREA_REQUEST });

            return axios.post('/area/add', data,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then( async (response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_AREA, payload: response.data });
                        // Re-fetch the current page to get updated data
                        await dispatch(getAreasWithPagination(
                            area.page || 1,           // current page
                            area.pageSize || 10,      // current page size
                            undefined,                  // include
                            area.search || '',        // current search
                            undefined,                  // searchCols
                            area.where || {},         // current filters
                            true                        // addTotal
                        ));
                        dispatch(addMasterInOption('areas', response.data));
                    } else {
                        dispatch({ type: AREA_REQUEST_FAILURE, error: 'Area create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: AREA_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: AREA_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
            throw error;
        }
    };
};

export const updateArea = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { area } = getState();
            dispatch({ type: AREA_REQUEST });
            return axios.put('/area/update', { id, data }, { params: { userId: auth.user?.id }}).then( async (response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_AREA, payload: { id, data: response.data } });
                    // Re-fetch the current page to get updated data
                    await dispatch(getAreasWithPagination(
                        area.page || 1,           // current page
                        area.pageSize || 10,      // current page size
                        undefined,                  // include
                        area.search || '',        // current search
                        undefined,                  // searchCols
                        area.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('areas', id, response.data));
                } else {
                    dispatch({ type: AREA_REQUEST_FAILURE, error: 'Area update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: AREA_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: AREA_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
            throw error;
        }
    };
};

export const deleteArea = (id) => {
    return async (dispatch, getState) => {
        try {
            const { area } = getState();
            dispatch({ type: AREA_REQUEST });
            return axios.delete(`/area/delete/${id}`).then( async (response) => {
                if (response.data) {
                    dispatch({ type: DELETE_AREA, id: id });
                    // Re-fetch the current page to get updated data
                    await dispatch(getAreasWithPagination(
                        area.page || 1,           // current page
                        area.pageSize || 10,      // current page size
                        undefined,                  // include
                        area.search || '',        // current search
                        undefined,                  // searchCols
                        area.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('areas', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: AREA_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: AREA_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};